import { Link, useLocation, useNavigate } from "react-router-dom";
import { SITE } from "@/lib/siteConfig";

const SECTIONS = [
    ["como-funciona", "Cómo funciona"],
    ["beneficios", "Beneficios"],
    ["precios", "Precios"],
    ["faq", "Preguntas frecuentes"],
];

export default function Footer() {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const goToSection = (id) => (e) => {
        e.preventDefault();
        if (pathname === "/") {
            const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
            document.getElementById(id)?.scrollIntoView({
                behavior: reduce ? "auto" : "smooth",
                block: "start",
            });
        } else {
            navigate(`/#${id}`);
        }
    };

    return (
        <footer
            data-testid="footer"
            className="border-t border-zinc-200 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
                    <div className="col-span-2 md:col-span-2">
                        <Link
                            to="/"
                            aria-label="Tiendify — Inicio"
                            className="inline-flex items-center gap-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 rounded-md"
                        >
                            <img
                                src="/assets/images/t-mark.png"
                                alt=""
                                width="32"
                                height="32"
                                className="w-8 h-8 object-contain"
                            />
                            <img
                                src="/assets/images/logo-text.png"
                                alt="Tiendify"
                                height="20"
                                className="h-5 w-auto object-contain"
                            />
                        </Link>
                        <p className="mt-4 text-[15px] text-[#4A4A4A] max-w-xs leading-relaxed">
                            Crea tu tienda en línea sin renta mensual. Cobros
                            con tarjeta y envíos a todo México desde un solo
                            panel.
                        </p>
                    </div>

                    <div>
                        <h4 className="text-xs font-semibold uppercase tracking-[0.15em] text-[#1A1A1A]">
                            Plataforma
                        </h4>
                        <ul className="mt-4 space-y-3">
                            {SECTIONS.map(([id, label]) => (
                                <li key={id}>
                                    <a
                                        href={`/#${id}`}
                                        onClick={goToSection(id)}
                                        className="text-[15px] text-[#4A4A4A] hover:text-primary transition-colors"
                                    >
                                        {label}
                                    </a>
                                </li>
                            ))}
                            <li>
                                <Link
                                    to="/registro?rol=merchant"
                                    className="text-[15px] text-[#4A4A4A] hover:text-primary transition-colors"
                                >
                                    Crear mi tienda
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-xs font-semibold uppercase tracking-[0.15em] text-[#1A1A1A]">
                            Legal
                        </h4>
                        <ul className="mt-4 space-y-3">
                            <li>
                                <Link
                                    to="/terminos"
                                    data-testid="footer-link-terms"
                                    className="text-[15px] text-[#4A4A4A] hover:text-primary transition-colors"
                                >
                                    Términos y condiciones
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/privacidad"
                                    data-testid="footer-link-privacy"
                                    className="text-[15px] text-[#4A4A4A] hover:text-primary transition-colors"
                                >
                                    Aviso de privacidad
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/login"
                                    className="text-[15px] text-[#4A4A4A] hover:text-primary transition-colors"
                                >
                                    Iniciar sesión
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 pt-8 border-t border-zinc-200 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-[#6B6B6B]">
                    <p>© {new Date().getFullYear()} {SITE.name}. Hecho en México.</p>
                    <p>{SITE.domain}</p>
                </div>
            </div>
        </footer>
    );
}
